// extracted by mini-css-extract-plugin
export var sectionContainer = "componentBlockConnector-module--sectionContainer--16703";
export var title = "componentBlockConnector-module--title--75720";